export default "__VITE_ASSET__D$aw_d9Z__"